import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreDataSecurityAccessExplainerByIdSlice } from './get';

export const coreDataSecurityAccessExplainerByIdReducers = combineReducers({
	get: getCoreDataSecurityAccessExplainerByIdSlice.asyncReducers
});

export const coreDataSecurityAccessExplainerByIdWatchers = combineAllWatchers([
	getCoreDataSecurityAccessExplainerByIdSlice.asyncWatchers
]);
